module.exports = __webpack_public_path__ + "static/media/game-score.c41fdd08.svg";